import React from 'react';
import cglLogo from 'assets/images/logo-cgl.svg';
import './logos.scss';

const Logos = () => {
	return (
		<div className='Logos'>
			<div className='Logos-karrierindsatsen'>
				<span>Udviklet af</span>
			</div>
			<div className='Logos-cgl' onClick={() => {window.open('https://cphgamelab.dk/', '_blank', 'noopener,noreferrer');}}>
				<img src={cglLogo} alt="Læringsspil udviklet af Copenhagen Game Lab" />
			</div>
		</div>
	);
};

export default Logos;